import { Box, styled } from '@planne-software/uni/mui/material';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  borderBottom: `1px solid ${theme.tokens.colors['border-color-neutral-soft']}`,
  paddingBottom: theme.tokens.spacing['spacing-sm'],
}));

export const Label = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-md-medium'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-strong'],
}));

export const PriceLine = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '0.125rem',
});

export const PriceValue = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['display-sm-bold'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const PriceSuffix = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-medium'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-strong'],
}));
